<div class="print-container">
    <h1 class="page-label">AbleNet - Shipment Validation</h1>
    <h4 class="page-label">Selected Portal: {{ portal?.name }} </h4>
</div>

<div class="tab-pane">
    <div>
        <div class="print-container">
            <div class="row">
                <div class="col-sm-3" style="text-align:right">
                <label class=" input-label" for="shipmentNbr-input">Shipment Number:</label>
                  </div>  
                  <div class="col-sm-6">
                    <input id="shipmentNbr" [(ngModel)]="shipmentNbr" class="form-control" type="text" [readonly]="isUiDisabled"
                    [disabled]="isUiDisabled" (keyup.enter)="onValidateClicked()" />
                </div>
            </div>
        </div>
    </div>
</div>

<div class="print-container">
    <div class="row">
        <button (click)="onValidateClicked()" class="submit btn btn-primary col-sm-3" [disabled]="isUiDisabled">VALIDATE</button>
    </div>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog></ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>